import { render } from "./AddMediaForm.vue?vue&type=template&id=2beeaa3d"
import script from "./AddMediaForm.vue?vue&type=script&lang=js"
export * from "./AddMediaForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/ContentMoverNodejs/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__